import { Dispatch, memo } from 'react';
import styles from './TableFooter.module.scss';
import TablePagination from '../../TablePagination/TablePagination';

interface ITableFooterProps {
  maxPages: number;
  currentPage: number;
  setCurrentPage: Dispatch<React.SetStateAction<number>>;
  pagination: boolean;
  className?: string;
}

/**
 * @param props - The props for the component.
 * @param pagination - Indicates whether table should have a pagination
 * @param className - Custom class name for table footer
 * @param currentPage - Current page number in table pagination
 * @param setCurrentPage - Function which is called after changing page
 * @param maxPages - Maximum pages count for table pagination
 * @returns A React component that displays the table footer.
 */

function TableFooterComponent(props: ITableFooterProps) {
  const { currentPage, maxPages, setCurrentPage, pagination, className } =
    props;
  return (
    <div className={[styles.tableFooter, className].join(' ')}>
      {pagination && (
        <TablePagination
          maxPages={maxPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
}

const TableFooter = memo(TableFooterComponent);

export default TableFooter;
